import gql from 'graphql-tag';

import { executeGqlQuery } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';
import type { BackendProject, BackendQueryProjectArgs } from 'src/types/backend';

const QUERY = gql`
  query ProjectStatus($id: Int!) {
    project(id: $id) {
      id
      status
      errors
    }
  }
`;

type Variables = BackendQueryProjectArgs;
type Result = Pick<BackendProject, 'id' | 'status' | 'errors'>;

export const queryProjectStatus = async (variables: Variables) => {
  const result = await executeGqlQuery({ query: QUERY, variables });
  return getSingleProp<Result>(result.data);
};
